/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatoreComuneCreationForm { 
    email: string;
    nome?: string;
    cognome?: string;
    comuni_ids?: Set<string>;
}

